<template>
  <div id="landing">
    <div class="fixed-wrapper">
      <div id="opacity-layer"/>
          <div id="landing-container">
            <b-container class="content-container" v-scroll-to="{ el: '#FeaturedProject', offset: global.screenWidth < 700 ? -45 :  -78 }" >
              <div class="content">
                <h1 id="home-title">gurin<b>.dev</b></h1>
                <h2 id="home-subtitle">
                  {{
                    languageHelper.translate("landing.sub1", {
                      locale: global.locale,
                    })
                  }}
                  <b>{{
                    languageHelper.translate("landing.sub1b", {
                      locale: global.locale,
                    })
                  }}</b>
                  {{
                    languageHelper.translate("landing.sub2", {
                      locale: global.locale,
                    })
                  }}
                  <b>{{
                    languageHelper.translate("landing.sub2b", {
                      locale: global.locale,
                    })
                  }}</b>
                  {{
                    languageHelper.translate("landing.sub3", {
                      locale: global.locale,
                    })
                  }}
                </h2>
              </div>
            </b-container>
            <div id="bottom-container">
              <div class="dyn-options">
                <div class="options">
                  <span
                    :class="`${global.locale === 'en' ? 'activeColor' : ''}`"
                    @click="
                      setLocale('en');
                      analyticsHelper.langChange('en');
                    "
                  >
                    {{
                      languageHelper.translate("common.english", {
                        locale: global.locale,
                      })
                    }}</span
                  ><span>/</span
                  ><span
                    :class="`${global.locale === 'fr' ? 'activeColor' : ''}`"
                    @click="
                      setLocale('fr');
                      analyticsHelper.langChange('fr');
                    "
                  >
                    {{
                      languageHelper.translate("common.french", {
                        locale: global.locale,
                      })
                    }}</span
                  >
                </div>
                <div class="options">
                  <span
                    @click="
                      setAutoDarkMode(true);
                      analyticsHelper.darkModeChange('auto');
                    "
                    :class="`${global.autoDarkMode ? 'activeColor' : ''}`"
                  >
                    Auto</span
                  >
                  <span>/</span>
                  <span
                    @click="
                      setAutoDarkMode(false);
                      setDarkMode(true);
                      analyticsHelper.darkModeChange('dark');
                    "
                    :class="`${
                      global.darkMode && !global.autoDarkMode
                        ? 'activeColor'
                        : ''
                    }`"
                  >
                    {{
                      languageHelper.translate("common.dark", {
                        locale: global.locale,
                      })
                    }}
                  </span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" v-bind:svg-inline="''" :class="`dark-icon ${
                      global.darkMode && !global.autoDarkMode
                        ? 'activeFillSvg'
                        : ''
                    }`" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M63.437 38.46a1 1 0 00-1.227.292c-1.28 1.665-2.945 3.2-4.95 4.562-11.618 7.881-27.545 4.925-35.497-6.595-7.816-11.32-4.99-26.974 6.296-34.894a1 1 0 00-.722-1.808c-4.648.696-9.207 2.49-13.188 5.19-7.178 4.869-12.007 12.22-13.596 20.7-1.582 8.442.24 16.994 5.13 24.08 6.288 9.106 16.487 14.006 26.856 14.006a32.49 32.49 0 0018.294-5.616c6.58-4.462 11.246-11.13 13.14-18.776a1 1 0 00-.536-1.14zM49.71 56.723c-13.871 9.41-32.885 5.883-42.38-7.872-4.586-6.642-6.295-14.66-4.812-22.574 1.49-7.952 6.02-14.847 12.754-19.415a30.468 30.468 0 018.365-3.973c-9.392 9.07-11.142 23.926-3.52 34.967 8.573 12.42 25.741 15.61 38.266 7.114.826-.561 1.6-1.15 2.318-1.765-2.22 5.443-6.024 10.15-10.991 13.518z"/></svg>
                  <span>/</span>
                  <span
                    @click="
                      setAutoDarkMode(false);
                      setDarkMode(false);
                      analyticsHelper.darkModeChange('light');
                    "
                    :class="`${
                      !global.darkMode && !global.autoDarkMode
                        ? 'activeColor'
                        : ''
                    }`"
                  >
                    {{
                      languageHelper.translate("common.light", {
                        locale: global.locale,
                      })
                    }}
                  </span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" v-bind:svg-inline="''" :class="`light-icon ${
                      !global.darkMode && !global.autoDarkMode
                        ? 'activeFillSvg'
                        : ''
                    }`" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#231F20" d="M31.324 25.224c0-3.86-3.141-7-7-7s-7 3.14-7 7c0 3.859 3.141 7 7 7s7-3.141 7-7zm-7 5c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zM23.324 34.09v6.134a1 1 0 102 0V34.09a1 1 0 10-2 0zM23.324 10.224v6.134a1 1 0 102 0v-6.134a1 1 0 10-2 0zM34.224 36.537a.997.997 0 001.414 0 .999.999 0 000-1.414L31.3 30.786a.999.999 0 10-1.414 1.414l4.338 4.337zM13.011 13.91a.999.999 0 000 1.414l4.338 4.337a.997.997 0 001.414 0 .999.999 0 000-1.414l-4.338-4.337a1 1 0 00-1.414 0zM39.324 24.224H33.19a1 1 0 100 2h6.134a1 1 0 100-2zM8.324 25.224a1 1 0 001 1h6.134a1 1 0 100-2H9.324a1 1 0 00-1 1zM34.224 13.91l-4.338 4.338a.999.999 0 101.414 1.414l4.338-4.338a.999.999 0 10-1.414-1.414zM13.718 36.83a.997.997 0 00.707-.293l4.338-4.337a.999.999 0 10-1.414-1.414l-4.338 4.337a.999.999 0 00.707 1.707z"/></svg>
                </div>
              </div>
              <div
                class="options socials"
              >
                   <a
                      @click="analyticsHelper.clickedLink('github - personal')"
                      href="https://github.com/danDoDev"
                      target="_blank"
                  >
                <img
                  :src="
                    require(!global.darkMode
                      ? '@/assets/images/icons/github-light.png'
                      : '@/assets/images/icons/github-dark.png')
                  "
                />
                </a>
                 <a
        @click="analyticsHelper.clickedLink('linkedin')"
        href="https://www.linkedin.com/in/daniel-gurin"
        target="_blank"
      >
                <img
                  :src="require('@/assets/images/icons/linkedin-small.png')"
                />
                </a>
              </div>
            </div>
            <div id="scroll-arrow" />
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { ScrollScene } from "scrollscene";
import { gsap, CSSPlugin, TimelineMax } from "gsap/all";
import { languageHelper, analyticsHelper } from "@/helpers";
import { mapActions, mapState } from "vuex";
gsap.registerPlugin(CSSPlugin);
export default {
  name: "Landing",
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      languageHelper,
      analyticsHelper,
      scrollScene: null,
    };
  },
  beforeDestroy() {
    this.destroyParalax();
  },
  mounted() {
    this.addScrollMagicEffects();
    window.addEventListener("scroll", () => {
      let scrollIndicator = document.getElementById("scroll-arrow");
      let landingContainer = document.getElementById("landing-container");
      scrollIndicator.style.display = window.scrollY > 50 ? "none" : "block";
      landingContainer.style.display =
        window.scrollY > window.innerHeight * 1.5 ? "none" : "block";
    });
  },
  methods: {
    addScrollMagicEffects() {
      const timeline = new TimelineMax({ paused: true })
        .to(
          "#home-title",
          2,
          {
            translateY: `+=${45}`,
            duration: 5,
            // scale: `+=1`
          },
          0
        )
        .to(
          "#home-subtitle",
          2,
          {
            translateY: `+=${90}`,
            duration: 10,
            opacity: `-=1`,
            scale: `-=0.2`,
          },
          0
        )
        .to("#bottom-container", 2, { opacity: `-=1`, duration: 10 }, 0)
        .to("#opacity-layer", 3, { opacity: `-=0.85`, duration: 20 }, 0.2)
        .to(
          "#landing-container",
          3,
          {
            scale: `-=0.89`,
            translateY: `-=${350}`,
            duration: 10,
            opacity: "-=1",
          },
          0.25
        );

      const ele = document.getElementById("upper-layer");

      const scrollScene = new ScrollScene({
        triggerElement: ele,
        gsap: {
          timeline: timeline,
        },
        duration: 800,
        offset: 20,
      });
      this.scrollScene = scrollScene;
    },
    destroyParalax() {
      this.scrollScene.destroy();
    },
    ...mapActions(["setLocale", "setDarkMode", "setAutoDarkMode"]),
  },
};
</script>

<style lang="scss" scoped>
$mobile: 1050px;
#landing {
  height: 100vh;
  position: relative;

  .fixed-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);
    padding: 60px;
    // min-height: 100vh;
    // min-height: calc(var(--vh, 1vh) * 100);
    // min-height: -webkit-fill-available;
    transition: background 0.9s ease-in-out;
    background-image: url("~@/assets/images/landing/toronto.jpeg");
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: left;

    @media (max-width: $mobile) {
      padding: 60px 30px;
    }
    @media (max-width: $md) {
      padding: 30px 0px;
    }
    @media (max-height: 350px) {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
  #opacity-layer {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background-color: $lt-bg-color;
    opacity: 0.85;
  }

  #landing-container {
    background: $lt-bg-color;
    width: 100%;
    display: block;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
    overflow: visible;
    padding-bottom: 42px;
    @media (max-height: $md) and (min-width: $lg) {
      flex-direction: row;
    }
    // @media (max-width: $lg) and (min-width: $lg) {
    //   flex-direction: row;
    // }
  }
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    position: relative;
    z-index: 1;
    cursor: pointer;

    @media (max-width: $md) {
      justify-content: flex-start;
    }
  }
  .content {
    padding-top: 100px;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    position: relative;
    @media (max-width: $mobile) {
      padding-left: 0;
      align-items: center;
    }
    @media (max-height: 790px) {
      padding-top: 24px;
      padding-bottom: 0;
    }
  }
  svg {
    path {
      fill: $lt-font-inactive;
    }
  }
  .activeFillSvg {
    path {
      fill: $lt-secondary-color;
    }
  }
  #bottom-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    width: 100%;
    position: relative;
    z-index: 1;
    margin-top: 32px;

    .dyn-options {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    @media (max-height: $md) {
      .dyn-options {
        flex-direction: row !important;
        flex-wrap: wrap;
        justify-content: flex-end;
      }
    }
    .options {
      padding: 25px;
      margin-bottom: 12px;
      margin-right: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      cursor: pointer;
      max-width: 100%;

      @media (max-height: $md) {
        padding: 7px;
      }
      span,
      img,
      svg {
        margin-right: 10px;
        font-size: 18px;
        font-family: $font-primary;
        &:last-child {
          margin-right: 0;
        }
      }

      svg,
      img {
        height: 30px;
        width: auto;
      }
      .dark-icon {
        height: 15px;
      }
      .light-icon {
        height: 25px;
      }
    }
    .socials {
      flex-wrap: nowrap;
      *:first-child {
        margin-right: 16px;
      }
    }
  }
  .activeColor {
    color: $lt-secondary-color;
  }
  #scroll-arrow {
    height: 0px;
    width: 2px;
    background: $lt-secondary-color;
    border-radius: 5px;
    -webkit-animation: arrowanim 3s linear infinite;
    position: absolute;
    bottom: 11vh;
    bottom: calc(var(--vh, 1vh) * 11);
    left: 50%;
    @media (max-width: $md) {
      // left: 5%;
      // bottom: -24px;
    }
  }
  h1 {
    font-size: 82px;
    color: $lt-gray;
    font-weight: 200;
    font-family: $font-primary;
    max-width: 100%;
    @media (max-width: $md) {
      font-size: 55px;
    }
    @media (max-height: 450px) {
      font-size: 45px;
    }
    @media (max-width: 270px) {
      font-size: 35px;
    }
  }
  h2 {
    font-size: 28px;
    color: #000;
    margin-top: 10px;
    font-family: $font-primary;
    max-width: 100%;
    @media (max-width: $mobile) {
      width: 400px;
      margin-top: 32px;
      text-align: center;
    }
    @media (max-width: $md) {
      font-size: 23px;
    }
    @media (max-height: 450px) {
      font-size: 23px;
    }
    @media (max-height: 390px) and (max-width: 992px) {
      display: none;
    }
    @media (max-width: 270px) {
      display: none;
    }
  }
  b {
    color: $lt-secondary-color;
  }
  span {
    color: $lt-dark-gray;
  }
  @-webkit-keyframes arrowanim {
    0% {
      height: 0;
      opacity: 0;
    }
    40% {
      height: 0;
      opacity: 0;
    }
    60% {
      height: 2vh;
      height: calc(var(--vh, 1vh) * 2);
      opacity: 0.2;
      transform: translate(0, 2vh);
    }
    80% {
      height: 8vh;
      height: calc(var(--vh, 1vh) * 8);
      opacity: 0.8;
      transform: translate(0, 8vh);
    }
    100% {
      height: 0;
      opacity: 0;
      transform: translate(0, 0vh);
    }
  }
}
</style>

<style lang="scss">
.dark {
  #landing {
    .fixed-wrapper,
    #landing-container,
    #scroll-arrow,
    .options {
      transition: background-color 0.25s ease-in;
    }
    .fixed-wrapper {
      background-color: $dt-bg-color;
      background-image: url("~@/assets/images/landing/toronto-night.jpeg");
      background-position: center;
    }
    #landing-container {
      background-color: $dt-primary-color;
    }

    #scroll-arrow {
      background-color: $dt-secondary-color;
    }
    #opacity-layer {
      background-color: $dt-bg-color;
    }
    .options {
      span {
        color: $dt-font-inactive;
      }
    }

    h1,
    h2,
    b,
    span {
      transition: color 0.25s ease-in;
    }
    h1 {
      color: $dt-gray;
    }
    h2 {
      color: #fff;
    }
    b {
      color: $dt-secondary-color;
    }
    span {
      color: $dt-dark-gray;
    }
  }

  svg {
    path {
      fill: $dt-font-inactive !important;
    }
  }
  .activeFillSvg {
    path {
      fill: $dt-secondary-color !important;
    }
  }
  .activeColor {
    color: $dt-secondary-color !important;
  }
}
</style>

